import { Box, IconButton, Input, InputGroup, InputRightElement, useToast } from '@chakra-ui/react'
import React, { useState } from 'react'
import { MdAttachFile } from 'react-icons/md'
import { useSendMessage } from './chat.hooks'

type ChatFooterType = {
  selectedContact: any
}

export const ChatFooter: React.FC<ChatFooterType> = ({selectedContact}) => {
  const [message, setMessage] = useState<string | undefined>(undefined)
  const { mutate, isLoading } = useSendMessage();

  const toast = useToast();

  const sendMessage = () => {
    const payload = {
      to: selectedContact.phoneNumber as string,
      from: process.env.REACT_APP_TWILIO_NUMBER as string,
      body: message as string
    }
    mutate(payload, {
      onSuccess: () => {
        toast({
          title: "Message Sent.",
          status: 'success',
          duration: 6000,
          isClosable: true,
          position: 'top-left',
        })
        setMessage("");
      },
      onError: (resp) => {
        toast({
          title: typeof resp === "string" ? resp : "Failed to send message. Invalid number",
          status: 'error',
          duration: 6000,
          isClosable: true,
          position: 'top-left',
        })
      }
    })

    
  }

  return (
    <Box bg="#F7FAFE" h="90px" display="flex" gap="5px" pt="10px" pb="10px" pl="25px" pr="0">
      <Box w="6%" justifyContent="end" display="flex" mt="17px">
        <IconButton
          minW="32px"
          minH="24px"
          maxW="32px"
          maxH="32px"
          aria-label="attach"
          colorScheme="brand"
          variant="unstyled"
          icon={<MdAttachFile color="#345EA6" width="32px" height="18px" fontSize="24px" />}
        />
      </Box>
      <Box w="90%" mt="15px">
        <InputGroup size="md">
          <Input
            placeholder="Type a message"
            pr="4.5rem"
            type="text"
            value={message}
            onChange={e => setMessage(e.target.value)}
          />
          <InputRightElement width="44px" mr="0px" mt="2px">
            <IconButton
              variant="unstyled"
              h="1.7rem"
              aria-label="send message"
              borderRadius="13px"
              minW="44px"
              icon={<SendIcon />}
              onClick={sendMessage}
              isDisabled={isLoading}
            />
          </InputRightElement>
        </InputGroup>
      </Box>
    </Box>
  )
}

const SendIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
      <path
        d="M10.1097 14.15L13.6897 10.56M7.39969 6.82L15.8897 3.99C19.6997 2.72 21.7697 4.8 20.5097 8.61L17.6797 17.1C15.7797 22.81 12.6597 22.81 10.7597 17.1L9.91969 14.58L7.39969 13.74C1.68969 11.84 1.68969 8.73 7.39969 6.82V6.82Z"
        stroke="#345EA6"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
